export default "__VITE_ASSET__WIWviMTk__"